import { useState } from "react";
import { manzanas } from "./constants";

export const useGetLandMap = () => {
  const [lend, setLends] = useState(null);

  const handleLendMap = async (land) => {
    const manzana = await manzanas.find((manzana) => {
      if (manzana.manzana === land.manzana) {
        return manzana;
      }
    });
    
    if (manzana.render) {
        setLends(manzana);
    }
  };

  return {
    lend,
    handleLendMap,
  };
};
